import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs3 from "./page_us/Solution-US-3/SectionUs3.js";




const PlafondsMursTendus = () =>{
     useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Mise à Niveau Maroc | Structures Techniques & Support – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Mise à niveau et structures techniques au Maroc avec UNIK SYSTEM : préparation des surfaces, support pour plafonds tendus et installations architecturales. Précision et stabilité."
  );

  setMeta(
    "keywords",
    "mise a niveau plafond maroc, structure technique maroc, preparation surface maroc, support plafond tendu maroc, nivellement mur plafond maroc, installation technique maroc, UNIK SYSTEM level"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/panneau-acoustique-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Mise à Niveau Maroc – Structures Techniques | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Solutions techniques pour préparation et installation de plafonds et murs au Maroc."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/US_LEVEL.bf16e3e163d5f8fff2a7.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/panneau-acoustique-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Mise à Niveau Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Préparation et structures techniques pour installations architecturales."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/US_LEVEL.bf16e3e163d5f8fff2a7.webp"
  );

  // ========= SCHEMA (TECHNICAL SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en mise à niveau et structures techniques pour installations architecturales au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Solutions Techniques",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Mise à Niveau Plafond"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Structure Technique Mur & Plafond"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-level");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-level";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Pourquoi faire une mise à niveau ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Pour garantir une surface stable et parfaite avant l’installation de plafonds ou murs techniques."
        }
      },
      {
        "@type": "Question",
        name: "Quels supports sont concernés ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Plafonds, murs et structures pour installations architecturales."
        }
      },
      {
        "@type": "Question",
        name: "Pourquoi choisir UNIK SYSTEM ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Expertise technique, précision d’installation et solutions adaptées aux projets professionnels."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-level");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-level";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);






  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs3/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;